/* eslint-disable import/prefer-default-export */
import { defineStore } from 'pinia';

import { TenantParamType } from '@api/types';

type TenantParamStoreStateType = {
  data: TenantParamType;
  initialized: boolean;
};

const initialState = (): TenantParamStoreStateType => ({
  data: {
    experienceTypes: [],
    jobCategories: [],
  },
  initialized: false,
});

export const useTenantParamStore = defineStore({
  id: 'tenantParam',
  state: initialState,
  actions: {
    $reset() {
      Object.assign(this, initialState());
    },
    set(data: TenantParamType): void {
      Object.keys(this.data).forEach((key) => {
        this.data[key] = data[key];
      });
      this.initialized = true;
    },
  },
});
